<ngx-spinner color="#cd0005"></ngx-spinner>

<div *ngIf="loaded" id="providers-view" class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
  <div class="mb-8">
    <h1 class="text-2xl font-bold text-gray-900">Airline Providers</h1>
  </div>
  <!-- Providers Table -->
  <div class="bg-white rounded shadow-sm overflow-hidden border border-gray-100">
    <div class="overflow-x-auto">
      <table class="min-w-full divide-y divide-gray-200">
        <thead class="bg-gray-50">
          <tr>
            <th
              scope="col"
              class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
            >
              Provider Name
            </th>
            <th
              scope="col"
              class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
            >
              Agency ID
            </th>
            <th
              scope="col"
              class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
            >
              PCC
            </th>
            <th
              scope="col"
              class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
            >
              Status
            </th>
          </tr>
        </thead>
        <tbody class="bg-white divide-y divide-gray-200">
          <tr class="provider-row" *ngFor="let airline of airlines | keyvalue">
            <td class="px-6 py-4 whitespace-nowrap">
              <div class="flex items-center">
                <div class="w-8 h-8 flex items-center justify-center bg-gray-900 rounded-full mr-3">
                  <span class="font-medium text-white">{{ airline.key }}</span>
                </div>
                <div>
                  <div class="text-sm font-medium text-gray-900">{{ airline.value.name }}</div>
                  <div class="text-xs text-gray-500">NDC API</div>
                </div>
              </div>
            </td>
            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
              {{ airline.value.agency_id || '—' }}
            </td>
            <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
              {{ airline.value.pcc || '—' }}
            </td>
            <td class="px-6 py-4 whitespace-nowrap">
              <span
                class="status-badge px-2 py-1 inline-flex text-xs leading-5 font-semibold rounded-full justify-center items-center cursor-pointer transition-all duration-300 hover:scale-[1.05]"
                [ngClass]="airline.value.active | providerStatusClasses: hoveredKey === airline.key"
                (mouseenter)="hoveredKey = airline.key"
                (mouseleave)="hoveredKey = null"
                (click)="toggleProvider(airline.key)"
              >
                {{ airline.value.active | providerStatusText: hoveredKey === airline.key }}
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
